import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { Store, select } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { TableType } from '@tv3/shared/empty-table/table-type'
import { MessageSidePanelService } from '@tv3/containers/inquiries/dialogs/message/message-side-panel.service'
import { Message } from '@tv3/store/message/message.model'
import { Guest } from '@tv3/store/guest/guest.model'
import { selectInquiriesByGuestId } from '@tv3/store/inquiry/inquiry.selectors'
import {
  Destroyable,
  distinctUntilChangedByIds,
  tokeetDashboardChannel,
  untilDestroy,
} from '@tokeet-frontend/tv3-platform'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import * as lodash from 'lodash'
import { v4 as uuid } from 'uuid'
import { combineLatest } from 'rxjs'
import { selectMessagesByGuestId } from '@tv3/store/message/message.selectors'
import { GetGuestMessages, MoveMessagesInConversationComplete } from '@tv3/store/message/message.actions'
import { Actions, ofType } from '@ngrx/effects'
import { MessageListComponent } from '@tv3/containers/messages/message-list/message-list.component'

@Component({
  selector: 'app-guest-email-list',
  templateUrl: './guest-email-list.component.html',
  host: { class: 'messages' },
  styleUrls: ['./guest-email-list.component.scss'],
})
export class EditGuestEmailListComponent extends Destroyable implements OnInit {
  @ViewChild(MessageListComponent) messageList: MessageListComponent

  @Input() guest: Guest

  inquiry: Inquiry
  emailMessages: Message[]

  tableType = TableType.GuestEmailsList
  get isMessagesCollapsed(): boolean {
    return this.messageList?.areAllMessagesCollapsed ?? false
  }

  get expandTooltip() {
    return this.isMessagesCollapsed ? $localize`Expand all messages` : $localize`Collapse all messages`
  }

  constructor(
    private store: Store<fromRoot.State>,
    private actions: Actions,
    private messageSidePanelService: MessageSidePanelService
  ) {
    super()
  }

  ngOnInit(): void {
    this.store.dispatch(GetGuestMessages({ guestId: this.guest.id }))
    this.actions.pipe(ofType(MoveMessagesInConversationComplete), untilDestroy(this)).subscribe(() => {
      this.store.dispatch(GetGuestMessages({ guestId: this.guest.id }))
    })

    combineLatest([
      this.store.pipe(select(selectInquiriesByGuestId(this.guest.id))),
      this.store.pipe(select(selectMessagesByGuestId(this.guest.id)), distinctUntilChangedByIds()),
    ])
      .pipe(untilDestroy(this))
      .subscribe(([inquiries, messages]) => {
        this.emailMessages = messages || []
        const headMessage = lodash.head(messages)
        const dummyInquiry = Inquiry.deserialize({
          account: this.guest.account,
          guest_id: this.guest.id,
          guest_details: { email: this.guest.primaryEmail, name: this.guest.name },
          convo_id: headMessage?.convoId || uuid(),
          inquiry_source: headMessage?.sentWith || tokeetDashboardChannel.name,
        })
        dummyInquiry.guest = this.guest
        this.inquiry = lodash.head(inquiries) || dummyInquiry
      })
  }

  onEdit(message: Message) {
    this.messageSidePanelService.open(message.inquiryId, message.id)
  }

  onRefreshMessages() {
    this.store.dispatch(GetGuestMessages({ guestId: this.guest.id }))
  }

  toggleMessagesCollapsing() {
    this.messageList.toggleCollapsing(!this.messageList.areAllMessagesCollapsed)
  }
}
